var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.383 53.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#594cda;}.cls-2{fill:#eb427e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-icon-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.521,29.333H67.383V50.672a2.738,2.738,0,0,1-2.806,2.661H19.326a2.735,2.735,0,0,1-2.806-2.659V29.333Zm0-26.672A2.738,2.738,0,0,1,19.326,0h45.25a2.736,2.736,0,0,1,2.806,2.661V24H16.521V2.661ZM33.475,8v5.333H50.429V8H33.475Zm0,29.333v5.333H50.429V37.333H33.475Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,16.278A13.528,13.528,0,0,0,3.048,18.367a13.224,13.224,0,0,0,2,18.867V48.76a0.974,0.974,0,0,0,.207.433,0.891,0.891,0,0,0,1.195.288l7.141-4.272,7.13,4.272a0.945,0.945,0,0,0,.46.119,0.864,0.864,0,0,0,.868-0.839V37.234c0-.617,1.448-1.318,2.065-2.089A13.425,13.425,0,0,0,22,16.278ZM13.614,30.827a4.073,4.073,0,1,1,4.073-4.073A4.073,4.073,0,0,1,13.614,30.827Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon4);
export default __webpack_public_path__ + "static/media/features-icon-4.5c105c60f23b4fb107834b4cca5156b6.svg";
export { ForwardRef as ReactComponent };